export default {
  setDatosFacturacionNegocioGest(state, d) {
    state.datosFacturacionNegocioGest = d;
  },
  setPedidosRango(state, p) {
    state.pedidosRango = p;
  },
  resetPedidosRango(state) {
    state.pedidosRango = [];
  },
  pushPedidosRango(state, p) {
    state.pedidosRango = [...state.pedidosRango, ...p]
  },
  setRangoFacturando(state, r) {
    state.rangoFacturando = r;
  },
  setFacturasArray(state, r) {
    state.facturasArray = r;
  },
  setOverlayPedidos(state, b) {
    state.overlayPedidos = b;
  },
  setEstadoFiltrando(state, v) {
    state.estadoFiltrando = v;
  },
  setSearch(state, v) {
    state.search = v;
  }
}